/* el-media-videos.js — sections/el-media-videos.liquid, sections/el-shower-mark.liquid
   Play a card's clip in place, and move the mobile progress line with the row. */
(function () {
  'use strict';
  /* Shared by several sections (media videos, shower mark) — bind once per page */
  if (window.elMediaVideosReady) return;
  window.elMediaVideosReady = true;

  function init(root) {
    (root || document).querySelectorAll('[data-el-media-videos]').forEach(function (section) {
      if (section.dataset.elReady) return;
      section.dataset.elReady = '1';
      var track = section.querySelector('[data-el-media-track]');
      var thumb = section.querySelector('[data-el-media-thumb]');
      var prev = section.querySelector('[data-el-media-prev]');
      var next = section.querySelector('[data-el-media-next]');
      if (!track || !thumb) return;
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        thumb.style.setProperty('--el-mv-progress', max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0);
        /* Desktop arrows: dimmed at either end */
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max - 1;
      };
      /* One card (plus its gap) per click */
      var step = function (direction) {
        var card = track.querySelector('[data-el-media-card]');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * ((card ? card.getBoundingClientRect().width : track.clientWidth) + gap), behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-el-media-play]');
    if (!button) return;
    var card = button.closest('[data-el-media-card]');
    var template = card && card.querySelector('template[data-el-media-player]');
    if (!template) return;
    /* one clip at a time */
    document.querySelectorAll('[data-el-media-card].is-playing video').forEach(function (v) { v.pause(); });
    var player = card.querySelector('video');
    if (!player) {
      card.appendChild(template.content.cloneNode(true));
      player = card.querySelector('video');
    }
    card.classList.add('is-playing');
    if (player) {
      /* The visitor tapped play, so start with sound (Shopify's video tag adds "muted"
         to autoplay videos, and phones then keep them silent). If the browser still
         refuses sound, fall back to muted playback rather than not playing at all. */
      player.removeAttribute('muted');
      player.muted = false;
      player.defaultMuted = false;
      player.volume = 1;
      var playing = player.play && player.play();
      if (playing && playing.catch) playing.catch(function () {
        player.muted = true;
        var retry = player.play();
        if (retry && retry.catch) retry.catch(function () {});
      });
      player.focus && player.focus();
    }
  });

  init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
